import { LearningSectionJsonModel } from '../../learning-section.json.model';
import {
  LearningSectionContainerJsonModel
} from '../../learning-section-container/learning-section-container.json.model';
import { HttpErrorResponse } from '@angular/common/http';
import { IFilters } from '../../../utils/component/base-filter-component/IFilter';

export namespace LearningSectionActions {
  export class Add {
    static readonly type = getActionName('Add');
    constructor(
      public payload: LearningSectionJsonModel,
      public filters?: IFilters
    ) {}
  }

  export class Edit {
    static readonly type = getActionName('Edit');
    constructor(
      public payload: LearningSectionJsonModel,
      public filters?: IFilters
    ) {}
  }

  export class EditRaw {
    static readonly type = getActionName('Edit Raw');
    constructor(
      public payload: LearningSectionJsonModel,
      public filters?: IFilters
    ) {}
  }

  export class EditContainer {
    static readonly type = getActionName('Edit LearningSectionContainer');
    constructor(
      public payload: LearningSectionJsonModel,
      public filters?: IFilters
    ) {}
  }

  export class Delete {
    static readonly type = getActionName('Delete');
    constructor(readonly payload: LearningSectionJsonModel) { }
  }

  export class Fetch {
    static readonly type = getActionName('Fetch');

    public include: string;
    public overrideOptions?: {
      pageNumber?: number
      pageSize?: number
      skipStoreDispatch?: boolean
    };

    constructor(
      include?: string,
      overrideOptions?: {
        pageNumber?: number
        pageSize?: number
        skipStoreDispatch?: boolean
      }
    ) {
      this.include = include === undefined ?
        'consumer,subjects,learningSectionContainers,learningSectionLayout' :
        include;

      this.overrideOptions = overrideOptions;
    }
  }

  export class FetchWithFilters {
    static readonly type = getActionName('Fetch with filters');
    constructor(readonly filters: IFilters) { }
  }

  export class FetchSuccess {
    static readonly type = getActionName('Fetch success');
    constructor(readonly payload: LearningSectionJsonModel[]) { }
  }

  export class FetchOne {
    static readonly type = getActionName('Fetch One');
    constructor(public id: string) { }
  }

  export class FetchOneSuccess {
    static readonly type = getActionName('Fetch One Success');
    constructor(public payload: LearningSectionJsonModel) { }
  }

  export class FetchOneFailure {
    static readonly type = getActionName('Fetch One Failure');
    constructor(public error: HttpErrorResponse) { }
  }

  export class FetchAppend {
    static readonly type = getActionName('Fetch and append');
    constructor(
      public overrideOptions?: {
        pageNumber?: number
        pageSize?: number
        skipStoreDispatch?: boolean
      }
    ) {}
  }

  export class FetchSuccessAppend {
    static readonly type = getActionName('Fetch success append');

    constructor(readonly payload: LearningSectionJsonModel[]) {
    }
  }

  export class UpdateLearningSectionContainers {
    static readonly type = getActionName('Update LearningSectionContainers');
    constructor(public payload: LearningSectionContainerJsonModel[]) { }
  }

  function getActionName(type: string) {
    return `[LearningSection] ${type}`;
  }
}
